import React, { Component } from 'react';
import LeaderboardRow from './LeaderboardRow';

class Leaderboards extends Component {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {

  }

  render() {
    
    if((this.props.females.length > 0 && !this.props.females[this.props.workoutIdx]) || (this.props.males.length > 0 && !this.props.males[this.props.workoutIdx])) {
      return (<div>No leaderboards yet!</div>);
    }
    return(<div className="relative flex h-100">
      <div className="relative w-50 h-100">
        <h3 className="title-gender relative white mv2 tl ml4 pv2">WOMEN</h3>
        <div className="leaderboard absolute top-0 h-100 w-100">
        {this.props.females.length === 0 ? (
            <h1>No Leaderboards</h1>
          ) : (
            this.props.females[this.props.workoutIdx].length === 0 ? (
              <h4 className="tl pl3">No Results yet! Post your results with the CrossFit btwb app</h4>
            ) :
            this.props.females[this.props.workoutIdx].map((doc, idx) => 
              <LeaderboardRow 
                {...doc}
                position={idx + 1}
                key={idx}
              />
            )
          )}
        </div>
      </div>
      <div className="relative w-50 h-100 border-left-light-blue">
        <h3 className="title-gender relative white mv2 tl ml4 pv2">MEN</h3>
        <div className="leaderboard absolute top-0 h-100 w-100">
          {this.props.males.length === 0 ? (
            <h1>No Leaderboards</h1>
          ) : (
            this.props.males[this.props.workoutIdx].length === 0 ? (
              <h4 className="tl pl3">No Results yet! Post your results with the CrossFit btwb app</h4>
            ) :
            this.props.males[this.props.workoutIdx].map((doc, idx) => 
              <LeaderboardRow 
                {...doc}
                position={idx + 1}
                key={idx}
              />
            )
          )}

        </div>
      </div>
    </div>)
  }
}

export default Leaderboards;


// WEBPACK FOOTER //
// ./src/components/Leaderboards.js